import React from 'react';

const CGVContent = () => {
  return (
    <div className="prose max-w-none space-y-6 sm:space-y-8">
      <section>
        <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">1. Objet et Champ d'Application</h2>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Les présentes conditions générales de vente (CGV) régissent les relations contractuelles entre 
          Agroref, ci-après dénommée « le Vendeur », et toute personne physique ou morale effectuant un achat 
          via notre site internet, ci-après dénommée « le Client ».
        </p>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Toute commande implique l'acceptation sans réserve par le Client des présentes CGV, qui prévalent 
          sur tout autre document, sauf conditions particulières expressément consenties par écrit par le Vendeur.
        </p>
        <p className="text-sm sm:text-base text-gray-700">
          Le Vendeur se réserve le droit de modifier les présentes CGV à tout moment. Les CGV applicables 
          sont celles en vigueur à la date de la commande du Client.
        </p>
      </section>

      <section>
        <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">2. Produits et Prix</h2>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Les produits proposés à la vente sont ceux figurant sur notre site internet, dans la limite des 
          stocks disponibles. Les caractéristiques essentielles des produits sont décrites et présentées 
          avec la plus grande exactitude possible.
        </p>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Les prix sont indiqués en dollars canadiens (CAD) et comprennent les taxes applicables 
          (TPS et TVQ). Les frais de livraison sont calculés séparément et clairement indiqués avant 
          la validation de la commande.
        </p>
        <p className="text-sm sm:text-base text-gray-700">
          Le Vendeur se réserve le droit de modifier ses prix à tout moment, étant entendu que les 
          produits seront facturés sur la base des tarifs en vigueur au moment de la validation de la commande.
        </p>
      </section>

      <section>
        <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">3. Commandes et Paiement</h2>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Les commandes sont passées exclusivement sur notre site internet. Le processus de commande comprend 
          les étapes suivantes : sélection des produits, identification du Client, vérification et validation 
          du contenu de la commande, acceptation des CGV, paiement.
        </p>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          La commande n'est définitivement confirmée et n'engage le Vendeur qu'à compter de l'envoi au Client 
          d'un courrier électronique de confirmation de commande.
        </p>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Le paiement s'effectue par virement bancaire. Le Client garantit qu'il dispose des autorisations 
          nécessaires pour utiliser le mode de paiement choisi.
        </p>
        <p className="text-sm sm:text-base text-gray-700">
          Les commandes sont traitées dans les plus brefs délais, sous réserve de disponibilité 
          des produits. Un email de confirmation vous sera envoyé après validation de votre commande.
        </p>
      </section>

      <section>
        <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">4. Livraison</h2>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Les délais de livraison sont donnés à titre indicatif. Ils dépendent notamment de la disponibilité 
          des transporteurs et de l'ordre d'arrivée des commandes.
        </p>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          La livraison est effectuée à l'adresse indiquée par le Client lors de la commande. Le Client est tenu 
          de vérifier l'état des produits à la livraison et de signaler toute anomalie dans un délai de 48 heures.
        </p>
        <p className="text-sm sm:text-base text-gray-700">
          Le Vendeur ne pourra être tenu responsable des retards ou défauts de livraison dus à des cas de 
          force majeure ou à des causes indépendantes de sa volonté, telles que des grèves, des intempéries, 
          ou des accidents de transport.
        </p>
      </section>

      <section>
        <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">5. Droit de Rétractation et Retours</h2>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Conformément à la législation en vigueur, le Client dispose d'un délai de 14 jours à compter de la 
          réception des produits pour exercer son droit de rétractation, sans avoir à justifier de motifs ni 
          à payer de pénalités.
        </p>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Pour exercer ce droit, le Client doit notifier sa décision de rétractation au Vendeur par courrier 
          électronique ou postal, en indiquant clairement son intention de se rétracter et les références de 
          sa commande.
        </p>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Les produits doivent être retournés dans leur état d'origine, complets (accessoires, notice...), dans 
          un emballage permettant un transport dans de bonnes conditions, et accompagnés d'une copie de la facture.
        </p>
        <p className="text-sm sm:text-base text-gray-700">
          Les frais de retour sont à la charge du Client. Le remboursement sera effectué dans un délai maximum 
          de 14 jours à compter de la réception des produits retournés, ou de la preuve d'expédition de ces 
          derniers, la date retenue étant celle du premier de ces faits.
        </p>
      </section>

      <section>
        <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">6. Garanties</h2>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Tous les produits vendus par le Vendeur bénéficient de la garantie légale de conformité et de la 
          garantie contre les vices cachés.
        </p>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          En cas de non-conformité d'un produit, le Client peut demander son remplacement ou son remboursement, 
          sous réserve des conditions de coût et de délai prévues par la loi.
        </p>
        <p className="text-sm sm:text-base text-gray-700">
          Pour bénéficier de la garantie, le Client doit signaler le défaut dans un délai raisonnable à 
          compter de sa découverte et fournir toute preuve du défaut constaté.
        </p>
      </section>

      <section>
        <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">7. Responsabilité</h2>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Le Vendeur s'engage à apporter tous les soins nécessaires à la fourniture d'un service de qualité. 
          Cependant, sa responsabilité ne pourra être engagée en cas d'inexécution ou de mauvaise exécution du 
          contrat due à un fait imprévisible et insurmontable d'un tiers ou à un cas de force majeure.
        </p>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Les produits vendus sont conformes à la réglementation en vigueur au Canada. La responsabilité du 
          Vendeur ne saurait être engagée en cas de non-respect de la législation du pays dans lequel les 
          produits sont livrés.
        </p>
        <p className="text-sm sm:text-base text-gray-700">
          Le Vendeur ne saurait être tenu pour responsable des dommages indirects ou immatériels, tels que 
          perte de profits, perte de chances, préjudice d'image, résultant de l'utilisation des produits.
        </p>
      </section>

      <section>
        <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">8. Propriété Intellectuelle</h2>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Tous les éléments du site internet (textes, images, logos, etc.) sont la propriété exclusive du 
          Vendeur ou font l'objet d'une autorisation d'utilisation. Toute reproduction, représentation, 
          modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le 
          moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable du Vendeur.
        </p>
        <p className="text-sm sm:text-base text-gray-700">
          Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera 
          considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des 
          articles L.335-2 et suivants du Code de Propriété Intellectuelle.
        </p>
      </section>

      <section>
        <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">9. Droit Applicable et Litiges</h2>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Les présentes CGV sont soumises au droit canadien. En cas de litige, les parties s'efforceront de 
          trouver une solution amiable. À défaut, le litige sera porté devant les tribunaux compétents de 
          la province de Québec.
        </p>
        <p className="text-sm sm:text-base text-gray-700">
          Pour toute réclamation, le Client peut contacter le service client du Vendeur par courrier 
          électronique ou postal.
        </p>
      </section>

      <section>
        <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">10. Dispositions Finales</h2>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Si une ou plusieurs stipulations des présentes CGV sont tenues pour non valides ou déclarées comme 
          telles en application d'une loi, d'un règlement ou à la suite d'une décision définitive d'une 
          juridiction compétente, les autres stipulations garderont toute leur force et leur portée.
        </p>
        <p className="text-sm sm:text-base text-gray-700 mb-2">
          Le fait pour le Vendeur de ne pas se prévaloir temporairement ou définitivement d'une ou plusieurs 
          stipulations des CGV n'emportera en aucun cas renonciation à s'en prévaloir ultérieurement.
        </p>
        <p className="text-sm sm:text-base text-gray-700">
          Les présentes CGV ont été mises à jour le 20 mars 2025.
        </p>
      </section>
    </div>
  );
};

export default CGVContent;
